import React, { useState } from "react";

import { useIntl } from "react-intl";

import { Modal, TextField } from "@mapmycustomers/ui";

interface Props {
  onHide: (name?: string) => void;
}

const SandboxNameModal: React.FC<Props> = ({ onHide }) => {
  const intl = useIntl();
  const [name, setName] = useState<string>("");
  return (
    <Modal
      cancelText={intl.formatMessage({
        id: "settings.sandbox.nameModal.cancel",
        defaultMessage: "Cancel",
        description: "Cancel button title in sandbox name modal",
      })}
      okButtonProps={{ disabled: name.trim().length === 0 }}
      okText={intl.formatMessage({
        id: "settings.sandbox.nameModal.ok",
        defaultMessage: "Next Step",
        description: "Cancel button title in sandbox name modal",
      })}
      onCancel={() => onHide()}
      onOk={() => onHide(name)}
      title={intl.formatMessage({
        id: "settings.sandbox.nameModal.title",
        defaultMessage: "Create Sandbox",
        description: "Title in sandbox name modal",
      })}
      visible
    >
      <TextField
        label={intl.formatMessage({
          id: "settings.sandbox.nameModal.description",
          defaultMessage: "Name your sandbox",
          description: "Description in sandbox name modal",
        })}
        onChange={setName}
        placeholder={intl.formatMessage({
          id: "settings.sandbox.nameModal.placeholder",
          defaultMessage: "e.g. Integration Testing",
          description: "Placeholder in sandbox name modal",
        })}
        value={name}
      />
    </Modal>
  );
};

export default SandboxNameModal;
